<template>
  <v-container fluid>
    <v-layout row wrap>
      <v-flex class="d-flex justify-space-between mb-3 align-center" xs12>
        <h3 class="font-weight-bold">Service Providers travellers</h3>
        <div class="text-xs-right">
<!--          <export-button-->
<!--              class="ml-2"-->
<!--              v-if="$oauth.checkIfHasPermission(['export service-provider'])"/>-->
<!--          <refresh-button :click-function="() => loadTravellers()"></refresh-button>-->
        </div>
      </v-flex>
      <v-flex xs12>
        <v-card>
          <v-divider></v-divider>
          <v-card-text class="pa-0">
            <v-data-table
                :headers="headers"
                :items="travellers"
                :loading="loading"
                :items-per-page="rowsPerPage"
                item-key="id"
                class="elevation-1"
                hide-default-footer
            >
              <template v-slot:item.s_no="{ index }">
                {{ (page - 1) * rowsPerPage + index + 1 }}
              </template>
              <template v-slot:item.display_image="{ item }">
                <file-display :src="item.display_image"></file-display>
              </template>
              <template v-slot:item.status="{ item }">
                <table-status :status="item.status"></table-status>
              </template>
              <template v-slot:item.lat="{ item }">
                {{ item.lat || '-' }}
              </template>
              <template v-slot:item.long="{ item }">
                {{ item.long || '-' }}
              </template>
              <template v-slot:item.remarks="{ item }">
                {{ item.remarks || '-' }}
              </template>
              <template v-slot:item.approved_rejected_by="{ item }">
                {{ item.approved_rejected_by ? item.approved_rejected_by.full_name : 'N/A' }}
              </template>


              <!-- Custom Footer -->
              <template v-slot:footer>
                <v-divider></v-divider>
                <div class="d-flex align-center justify-space-between pa-3 flex-wrap">

                  <!-- Rows per page -->
                  <div class="d-flex align-center">
                    <span class="grey--text caption mr-2">Rows per page:</span>
                    <v-select
                        v-model="rowsPerPage"
                        :items="rowsPerPageOptions"
                        dense
                        hide-details
                        outlined
                        style="max-width: 80px; font-size: 13px;"
                        @change="onRowsPerPageChange"
                    ></v-select>
                  </div>

                  <!-- Record count -->
                  <div class="grey--text caption mx-4">
                    Showing
                    {{ total === 0 ? 0 : (page - 1) * rowsPerPage + 1 }}–{{ Math.min(page * rowsPerPage, total) }}
                    of {{ total }} records
                  </div>

                  <!-- Prev / Next -->
                  <div class="d-flex align-center">
                    <v-btn
                        icon small
                        :disabled="page <= 1 || loading"
                        @click="prevPage"
                    >
                      <v-icon>mdi-chevron-left</v-icon>
                    </v-btn>

                    <span class="mx-2 caption grey--text">
                      Page {{ page }} of {{ totalPages }}
                    </span>

                    <v-btn
                        icon small
                        :disabled="page >= totalPages || loading"
                        @click="nextPage"
                    >
                      <v-icon>mdi-chevron-right</v-icon>
                    </v-btn>
                  </div>

                </div>
              </template>

            </v-data-table>
          </v-card-text>
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import FileInput from "../components/FileInput";
import {commonListMixin} from "../mixins/commonListMixin";
import FormErrorDisplayHandler from "../components/FormErrorDisplayHandler";
import {validationMixin} from "../mixins/validationMixin";
import RefreshButton from "@/components/RefreshButton";
import FileDisplay from "../components/FileDisplay";
import {mapActions, mapGetters} from "vuex";
import TableStatus from "@/components/TableStatus";
import Http from "axios";
import {API_URL, VERSION} from "../config/config";

export default {
  name: "ServiceProvider",
  components: {FileDisplay, RefreshButton, FormErrorDisplayHandler, FileInput, TableStatus},

  data() {
    return {
      model: "service-provider",
      types: [],
      travellers: [],
      page: 1,
      rowsPerPage: 50,
      rowsPerPageOptions: [10, 25, 50, 100],
      totalPages: 0,
      total: 0,
      loading: false,
      status: [
        { id: -1, name: 'All' },
        { id: 0,  name: 'Applied/Pending' },
        { id: 1,  name: 'Approved' },
        { id: 3,  name: 'Rejected' },
      ],
      headers: [
        { text: 'S.N.',            value: 's_no',                  sortable: false },
        { text: "Country",         value: "country_name",          sortable: false },
        { text: "Service Provider",value: "service_provider_name", sortable: false },
        { text: "Traveller",       value: "traveller_name",        sortable: false },
        { text: "Purpose",         value: "purpose_name",          sortable: false },
        { text: 'Document Number', value: 'document_number',       sortable: false },
        { text: 'Action Date',     value: 'action_date',           sortable: false },
      ],
    };
  },

  mixins: [commonListMixin, validationMixin],

  computed: {
    ...mapActions('ServiceProvider', ['getAllServiceProviderTypes']),
    ...mapGetters({
      service_provider_types:     'ServiceProvider/serviceProviderTypes',
      service_provider_purposes:  'ServiceProvider/serviceProviderTypePurposes',
      trekkingAgencyCount:        'ServiceProvider/trekkingAgencyCount',
      serviceProviderCount:       'ServiceProvider/serviceProviderCount',
      totalCount:                 'ServiceProvider/totalCount'
    }),
    serviceProviders() {
      return this.$store.state.CommonList.all;
    },
  },

  methods: {
    view(item) {
      this.$router.push({
        name: "ViewServiceProvider",
        params: { id: item.id }
      });
    },

    edit(item) {
      // handle edit
    },

    async confirmDelete(item) {
      // handle delete
    },

    onRowsPerPageChange() {
      this.page = 1;
      this.loadTravellers();
    },

    prevPage() {
      if (this.page > 1 && !this.loading) {
        this.page--;
        this.loadTravellers();
      }
    },

    nextPage() {
      if (this.page < this.totalPages && !this.loading) {
        this.page++;
        this.loadTravellers();
      }
    },

    async loadTravellers() {
      const providerId = this.$route.params.id;
      if (!providerId) return;

      this.loading = true;

      const url = `${API_URL}${VERSION}/service-provider-travellers-count/${providerId}`;

      try {
        const response = await Http.get(url, {
          params: {
            page: this.page,
            rowsPerPage: this.rowsPerPage,
          }
        });

        const { data, last_page, total } = response.data;

        this.travellers  = data;
        this.totalPages  = last_page || 1;
        this.total       = total || 0;

      } catch (error) {
        console.error('Error fetching travellers:', error);
      } finally {
        this.loading = false;
      }
    },
  },

  async mounted() {
    await this.loadTravellers();
  }
}
</script>

<style scoped>
</style>